/**
 * Employment Form Configuration Constants
 * Centralized configuration for form fields, messages, and settings
 */

export const FORM_CONFIG = {


  // Search configuration
  SEARCH: {
    MIN_CHARACTERS: {
      ORGANIZATION: 2,
      DESIGNATION: 1,
      DEPARTMENT: 1,
    },
    DEBOUNCE_MS: 300,
    LIMITS: {
      ORGANIZATIONS: 10,
      DESIGNATIONS: 25,
      EMPLOYMENT_TYPES: 50,
      DEPARTMENTS: 50,
    },
  },

  // Section configuration
  SECTION: {
    NAME: 'employment-history-section',
    REQUIRED: false,
    PRIVACY_DISABLED: false,
  },
} as const;

export const DEFAULT_DISPLAY_STATUS = 2; // Visible by default
export const HIDDEN_DISPLAY_STATUS = 1;
export const PRESENT_DATE_VALUE = 'Present'; // Keep as 'Present' for backend data consistency 